import React from "react"
import styled from "styled-components"

import imgSrc from "@irati/ui/images/merchanside_checkout_success.png"
import mainTheme from "@irati/ui/src/global/theme"
import {H2} from "@irati/ui/src/Typography"
import {FormattedMessage} from "@irati/utils/lang"
import Flex from "@irati/ui/src/Flex"

export const OrderNotFound = () => {
  return (
    <Container direction="column" alignItems="center">
      <img src={imgSrc} alt="basket img" />
      <H2 textAlign="center" marginTop={mainTheme.spacing.four} marginBottom={mainTheme.spacing.three}>
        <FormattedMessage id="flexiRewards.merchandise.success.error.orderNotFound" />
      </H2>
    </Container>
  )
}

const Container = styled(Flex)`
  margin-top: 20%;
  text-transform: uppercase;

  img {
    filter: grayscale(1);
  }
`
